import { AnyAction } from '@reduxjs/toolkit'
import { all, takeEvery } from 'redux-saga/effects'
import { defaultFlow } from 'redux/config/saga/Common'
import { bikeCatalogActions } from './bikeCatalogSlice'
import bikeCatalogService from './bikeCatalogService'

export function* getAllBikes(action: AnyAction) {
  yield defaultFlow(
    action,
    bikeCatalogService.getAllBikes,
    bikeCatalogActions.getAllBikesSuccess
  )
}

export function* watchGetAllBikes() {
  yield takeEvery(bikeCatalogActions.getAllBikes.type, getAllBikes)
}

export default function* bikeCatalogSaga() {
  yield all([watchGetAllBikes()])
}
